import React from 'react';
import {Link} from 'react-router';
import * as pathConstants from '../../constants/pathConstants';

class PageNotFoundPage extends React.Component {
  render() {
    return (
      <div>
        Whoops this page doesn't exist, click <Link to={pathConstants.pathToLogin}>here</Link> {}
        to go back.
      </div>
    );
  }
}

export default PageNotFoundPage;



/** WEBPACK FOOTER **
 ** ./src/components/common/PageNotFoundPage.js
 **/